import { Record, Map } from "immutable";

export default Record({
  isRemoveModalVisible: false,
  loading: false,
  defaultLocale: "pl",
  locales: null
});



// WEBPACK FOOTER //
// ./src/common/locales/locales.js